import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import GridOnIcon from '@material-ui/icons/GridOn'
import PeopleIcon from '@material-ui/icons/People'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { getWord, WID } from '../../../constants/Language';

const styles = theme => ({
})

class ChatMenu extends React.Component {
  render() {
    const { classes, anchorEl, selectedMenu, isVisibleChatCard, handleClick, handleClose, handleSendBoard, handleUserList, handleShow, handleHide, handleExited, language } = this.props
    return (
      <React.Fragment>
        <IconButton onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onExited={handleExited(selectedMenu)}
        >
          {isVisibleChatCard === true && (
          <MenuItem onClick={handleSendBoard}>
            <ListItemIcon>
              <GridOnIcon/>
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.primary }} inset primary={getWord(WID.CHAT_MENU.SEND_BOARD, language)} />
          </MenuItem>
          )}
          <MenuItem onClick={handleUserList}>
            <ListItemIcon>
              <PeopleIcon/>
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.primary }} inset primary={getWord(WID.CHAT_MENU.USER_LIST, language)} />
          </MenuItem>
          {isVisibleChatCard === true && (
          <MenuItem onClick={handleHide}>
            <ListItemIcon>
              <VisibilityOffIcon/>
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.primary }} inset primary={getWord(WID.CHAT_MENU.HIDE, language)} />
          </MenuItem>
          )}
          {isVisibleChatCard === false && (
          <MenuItem onClick={handleShow}>
            <ListItemIcon>
              <VisibilityIcon/>
            </ListItemIcon>
            <ListItemText classes={{ primary: classes.primary }} inset primary={getWord(WID.CHAT_MENU.SHOW, language)} />
          </MenuItem>
          )}
        </Menu>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(ChatMenu)


// WEBPACK FOOTER //
// ./src/components/Common/Chat/ChatMenu.js